import React, { Component, useState } from 'react';
import LandingPageView from './LandingPageView';
import { withStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next'
import { paths } from '../../../portal.router.config';
import { saveDataIntoAsyncStore, getLanguage, getAppCfg } from '../../utils/common';
import i18n from '../../translations/i18n'
import { domainName, portal_config } from '../../../portal.config';
import ModalConfirm from '../../components/ModalConfirm'
import t from '../../utils/translateUtil';
const styles = theme => ({

});
function LandingPage(props){
    const [language, setLanguage] = useState(getLanguage("LANGUAGE"));
    const [showLoading, onShowLoading] = useState(false);
    const [confirm, setConfirm] = useState({})

    const onChangeLanguage = () => {
        let new_language = language
        if (language === 'ENG')
            new_language = 'GR'
        else
            new_language = 'ENG'


        setLanguage(new_language);
        saveDataIntoAsyncStore('LANGUAGE', new_language);
        i18n.changeLanguage(new_language);
    }
    const onLogin = async() => {
        props.history.push(paths.login);
    }
    const onRegister = async() => {
        console.log("AAAAAA onRegister====", domainName);
        let appConfig = getAppCfg()
        let isEmailPassword = appConfig && appConfig.auth_support && appConfig.auth_support.email_password;
        if(domainName == 'airlink')
            props.history.push(paths.register);
        if (portal_config[domainName].isCredentials && isEmailPassword)
            showConfirm(true, t('exits_rewards_participant'));
        else
            props.history.push(paths.register);
    }
    const onYesExistRewards = async() =>{
        props.history.push(paths.identify);
        showConfirm(false)
    }
    const onNoExistRewards = () => {
        props.history.push(paths.register);
        showConfirm(false)
    }
    const showConfirm = (status, message) => {
        onShowLoading(false);
        setConfirm({ show: status,content: message ? message : null})
    }
    return(
        <div>
                <LandingPageView 
                    onLogin={onLogin}
                    onRegister={onRegister}
                    onChangeLanguage={onChangeLanguage}
                    language={language} />
                {confirm && <ModalConfirm
                    open={confirm.show}
                    onClose={onNoExistRewards}
                    message={confirm.content}
                    confirm={t('yes')}
                    buttonLabel={t('no')}
                    onAction={onYesExistRewards}
                />}
            </div>
    )
}


export default withStyles(styles)(withTranslation()(LandingPage));